<div class="container">
  <div class="status">
    <div *ngIf="lastEventActive.stepId!=0" class="status_label">{{lastEventActive.labelShort}}</div>
    <div *ngIf="lastEventActive.stepId===0" class="status_label0">{{lastEventActive.labelShort}}</div>
    <div class="status_date" *ngIf="lastEventActive.date">
      {{lastEventActive.date|date:"EEEE d MMMM" :'': 'fr' }} </div>
  </div>
  <div class="timeline_container" *ngIf="lastEventActive.stepId!=0">
    <div class="progress-bar">
      <div class="point-container_one">
        <div class="point" [ngStyle]="{'background-color' : getProgression() >= 0? '#EE7203':'#F8F0CB'}" dataqsi="progressPoint-1"></div>
        <img class="timeline-pictos" src="assets/images/annonces-colis.svg"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 1? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'lightgrey'}" dataqsi="timelinePicto-1">
      </div>
      <div class="point-container">
        <div class="point" [ngStyle]="{'background-color' : getProgression() >= 25? '#EE7203':'#F8F0CB'}" dataqsi="progressPoint-2"></div>
        <img class="timeline-pictos" src="assets/images/transport-routier.svg" *ngIf="isNat"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 2? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'lightgrey'}" dataqsi="timelinePicto-2">
        <img class="timeline-pictos" src="assets/images/avion.svg" *ngIf="!isNat"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 2? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'lightgrey'}" dataqsi="timelinePicto-2">
      </div>
      <div class="point-container">
        <div class="point" [ngStyle]="{'background-color': getProgression() >= 50? '#EE7203':'#F8F0CB'}" dataqsi="progressPoint-3"></div>
        <img class="timeline-pictos" src="assets/images/pfc.svg" *ngIf="isNat"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 3? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'lightgrey'}" dataqsi="timelinePicto-3">
        <img class="timeline-pictos" src="assets/images/stop-douane.svg" *ngIf="!isNat"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 3? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'opacity(30%) contrast(0)'}" dataqsi="timelinePicto-3">
      </div>
      <div class="point-container">
        <div class="point" [ngStyle]="{'background-color' : getProgression() >= 75? '#EE7203':'#F8F0CB'}" dataqsi="progressPoint-4"></div>
        <img class="timeline-pictos" src="assets/images/facteur.svg" *ngIf="isNat"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 4? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'lightgrey'}" dataqsi="timelinePicto-4">
        <img class="timeline-pictos" src="assets/images/livraison.svg" *ngIf="!isNat"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 4? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'opacity(30%) contrast(0)'}" dataqsi="timelinePicto-4">
      </div>
      <div class="point-container_five">
        <div class="point" [ngStyle]="{'background-color' : getProgression() >= 100? '#EE7203':'#F8F0CB'}" dataqsi="progressPoint-5"></div>
        <img class="timeline-pictos" src="assets/images/livraison-a-adresse.svg"
          [ngStyle]="{ 'filter' : lastEventActive.stepId >= 5? 'invert(48%) sepia(79%) saturate(2467%) hue-rotate(3deg) brightness(97%) contrast(98%)' : 'lightgrey'}" dataqsi="timelinePicto-5">
      </div>
      <progress id="progress" [value]="getProgression()" [max]="100" dataqsi="progressBar"></progress>
    </div>
  </div>
  <div class="underTL_container">
    <div class="prospectiveDeliveryDate_container" *ngIf="showUnderTimeline">
      <div class="prospectiveDeliveryDate_title">{{shortLabel4Step5}}</div>
      <div class="prospectiveDeliveryDate_date">{{dateStep5|date:"EEEE d MMMM":'':'fr'}} {{timeSlot}}
      </div>
    </div>
    <div class="furtherInfos_container" *ngIf="lastEventActive.labelLong">
      <div class="furtherInfos_title">{{"timeline.further_info" | translate}}</div>
      <div class="furtherInfos_label">{{lastEventActive.labelLong}}</div>
    </div>
  </div>

  <div class="timeline_map_container" *ngIf="showYourMap">
    <div class="tracking_map" (click)="callMap()">
      <div class="button">
        <img src="assets/images/icon-map.png" class="button_icon">
        <div class="button_action">carte de livraison</div>
      </div>
    </div>
  </div>

  <div class="qrcode_container" *ngIf="confidentialCode != '' && idLastEventActive !== 5">
    <app-qrcode [confidentialCode]="confidentialCode"></app-qrcode>
  </div>

</div>



